"use strict";
exports.__esModule = true;
exports.fileSize = exports.FileSizeThresh = void 0;
var FileSizeThresh;
(function (FileSizeThresh) {
    FileSizeThresh[FileSizeThresh["Binary"] = 1024] = "Binary";
    FileSizeThresh[FileSizeThresh["Decimal"] = 1000] = "Decimal";
})(FileSizeThresh = exports.FileSizeThresh || (exports.FileSizeThresh = {}));
var localizedUnits = function (locale) {
    var _a, _b;
    return locale.includes('fr')
        ? (_a = {},
            _a[FileSizeThresh.Binary] = [
                'o',
                'Kio',
                'Mio',
                'Gio',
                'Tio',
                'Pio',
                'Eio',
                'Zio',
                'Yio',
            ],
            _a[FileSizeThresh.Decimal] = [
                'o',
                'ko',
                'Mo',
                'Go',
                'To',
                'Po',
                'Eo',
                'Zo',
                'Yo',
            ],
            _a) : (_b = {},
        _b[FileSizeThresh.Binary] = [
            'B',
            'KiB',
            'MiB',
            'GiB',
            'TiB',
            'PiB',
            'EiB',
            'ZiB',
            'YiB',
        ],
        _b[FileSizeThresh.Decimal] = [
            'B',
            'kB',
            'MB',
            'GB',
            'TB',
            'PB',
            'EB',
            'ZB',
            'YB',
        ],
        _b);
};
var fileSize = function (bytes, locale, thresh) {
    if (thresh === void 0) { thresh = FileSizeThresh.Binary; }
    var units = localizedUnits(locale)[thresh];
    var u = 0;
    while (Math.abs(bytes) >= thresh && u < units.length) {
        bytes /= thresh;
        ++u;
    }
    return (u !== 0 ? bytes.toFixed(0) : bytes) + " " + units[u];
};
exports.fileSize = fileSize;
//# sourceMappingURL=fileSize.js.map